<template>
  <v-card class="pa-4">
    <v-alert
      v-model="alertShow"
      v-if="errorMessage"
      type="warning"
      variant="tonal"
      @click:close="closedMessege()"
      closable
      >{{ errorMessage }}</v-alert
    >
    <v-row justify="end">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          hide-details
          append-inner-icon="mdi-magnify"
          variant="underlined"
          label="Поиск"
          style="width: 100%"
        ></v-text-field>
        <div class="d-flex justify-end mt-4 mb-6">
          <v-btn color="primary" @click="openEditDialog()"
            >Добавить предмет
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="subjects"
      :search="search"
      item-value="id"
      :loading="loading"
    >
      <template #item.index="{ index }">{{ index + 1 }}</template>
      <template #item.actions="{ item }">
        <v-icon color="teal darken-1" class="me-2" @click="openEditDialog(item)"
          >mdi-pencil</v-icon
        >
        <v-icon
          color="red darken-3"
          class="me-2"
          @click="openDeleteDialog(item)"
          >mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <!-- Диалог редактирования -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-form @submit.prevent ref="myform">
        <v-card>
          <v-card-title class="text-h6">
            {{ editedItem.id ? "Редактировать" : "Добавить" }} предмет
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="editedItem.name"
                  hide-details="auto"
                  label="Название"
                  :rules="[(v) => !!v || 'Обязательно']"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  label="Тип"
                  item-text="name"
                  :items="types"
                  v-model="editedItem.ed_type"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="editDialog = false">Отмена</v-btn>
            <v-btn color="primary" @click="saveSubject">Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Диалог подтверждения удаления -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">Подтверждение удаления</v-card-title>
        <v-card-text>
          Вы уверены, что хотите удалить предмет
          <strong>{{ selectedItem?.name }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Отмена</v-btn>
          <v-btn color="red" @click="deleteSubject">Удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay
      v-model="processData"
      persistent
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      subjects: [],
      types: [],
      headers: [
        { title: "#", value: "index", sortable: false },
        { title: "Наименование", value: "name" },
        { title: "Тип", value: "ed_type" },

        {
          title: "Действия",
          value: "actions",
          width: "160px",
          sortable: false,
        },
      ],
      editDialog: false,
      deleteDialog: false,
      editedItem: {},
      selectedItem: null,
      loading: true,
      processData: false,
      errorMessage: "",
      alertShow: "",
    };
  },
  created() {
    this.fetchSubject();
  },
  methods: {
    fetchSubject() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/dictionaries/certificateSubjects/getCertificateSubjects"
        )
        .then((response) => {
          this.subjects = response.data.subjects;
          this.types = response.data.types;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openEditDialog(item = null) {
      this.editedItem = item
        ? { ...item }
        : { id: null, name: "", ed_type: null };
      this.editDialog = true;
    },
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    deleteSubject() {
      this.processData = true;

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/dictionaries/certificateSubjects/DeletedSubject",
          new URLSearchParams({ id: this.selectedItem.id })
        )
        .then((response) => {
          if (typeof response.data === "string") {
            this.errorMessage = response.data;
            this.alertShow = true;
          } else {
            this.subjects = response.data.subjects;
          }
        })
        .catch(() => {
          this.errorMessage = "Ошибка при удалении.";
          this.alertShow = true;
        })
        .finally(() => {
          this.deleteDialog = false;
          this.processData = false;
        });
    },
    closedMessege() {
      this.alertShow = false;
      this.errorMessage = "";
    },
    async saveSubject() {
      const { valid } = await this.$refs.myform.validate();
      if (!valid) return;

      // Проверка на дубликат
      const isDuplicate = this.subjects.some(
        (s) =>
          s.name.trim().toLowerCase() ===
            this.editedItem.name.trim().toLowerCase() &&
          s.ed_type == this.editedItem.ed_type &&
          s.id !== this.editedItem.id
      );
      if (isDuplicate) {
        this.errorMessage = "Такой предмет уже существует.";
        this.alertShow = true;
        this.editDialog = false;
        return;
      }
      this.processData = true;

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/dictionaries/certificateSubjects/addSubject",
          new URLSearchParams({
            item: JSON.stringify(this.editedItem),
          })
        )
        .then((response) => {
          this.subjects = response.data.subjects;
        })
        .catch(() => {
          this.errorMessage = "Ошибка при сохранении.";
          this.alertShow = true;
        })
        .finally(() => {
          this.editDialog = false;
          this.processData = false;
        });
    },
  },
};
</script>